import type { SxProps, Theme } from '@mui/material/styles';

export const SVGStyles: SxProps<Theme> = {
  display: 'inline-block',
  verticalAlign: 'middle',
  '& .fill, & rect, & circle, & polygon': { fill: 'currentColor' },
  '& .stroke, & line, & polyline': { stroke: 'currentColor' },
};
